import { registerPlugin } from '@capacitor/core';

// "Hej Siri, prata med Q i Qvenari" (iOS: App/QSiri.swift). Intenten öppnar appen; här frågar webben om Siri
// bett om Q – när appen startar, när den kommer tillbaka i förgrunden och när händelsen "listen" kommer – och
// öppnar då Q i lyssnande läge. Den senast registrerade hanteraren tar anropet: under jakt jaktens lilla
// Q-kort (KartaTab), annars toppradens Q (App).

interface QLaunchPluginApi {
  consume(): Promise<{ listen: boolean }>;
  addListener(event: 'listen', cb: () => void): Promise<{ remove: () => Promise<void> }>;
}

const QLaunch = registerPlugin<QLaunchPluginApi>('QLaunch');

type Handler = () => void;
const handlers: Handler[] = [];
let pending = false;

/** Registrerar en hanterare (senast registrerad går först). Returnerar en funktion som tar bort den. */
export function onQLaunch(h: Handler): () => void {
  handlers.push(h);
  if (pending) { pending = false; h(); }
  return () => { const i = handlers.lastIndexOf(h); if (i >= 0) handlers.splice(i, 1); };
}

/** Kör den översta hanteraren, eller sparar anropet tills någon registrerar sig. Exporterad för tester. */
export function dispatchQLaunch() {
  const h = handlers[handlers.length - 1];
  if (h) h(); else pending = true;
}

function available(): boolean {
  const cap = (window as any).Capacitor;
  return !!cap?.isNativePlatform?.() && !!cap.isPluginAvailable?.('QLaunch');
}

async function check() {
  try {
    if ((await QLaunch.consume()).listen) dispatchQLaunch();
  } catch { /* äldre appbygge utan pluginen */ }
}

let started = false;
/** Startas en gång (App): frågar direkt, vid händelsen och när appen blir synlig igen. */
export function startQLaunch() {
  if (started || !available()) return;
  started = true;
  void check();
  void QLaunch.addListener('listen', () => { void check(); }).catch(() => {});
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') void check(); });
}
